// extracted by mini-css-extract-plugin
module.exports = {"Container":"Tbody_Container__qFwHt","NoRecords":"Tbody_NoRecords__3C7qi","LoadMore":"Tbody_LoadMore__1mEJI"};